import { Box, Container, Typography } from "@helo/ui";
import { ITrackingResponse } from "@swyft/swyft-common";

interface PhotoProps {
  photos: ITrackingResponse["photoURLs"];
}

const Photos = (props: PhotoProps) => {
  const { photos } = props;

  if (!photos || !photos.length) return <></>;

  return (
    <Box component="section" className="gradient-vibrant-blue" id="photos">
      <Container className="section">
        <Typography
          variant="h2"
          fontWeight={700}
          sx={({ palette }) => ({ color: palette.primary.contrastText })}
        >
          Proof of Delivery
        </Typography>

        <div className="gallery-wrapper">
          {photos.map((photo) => (
            <div className="gallery-item" key={`pod-${photo}`}>
              <img alt="" src={photo} />
            </div>
          ))}
        </div>
      </Container>
    </Box>
  );
};

export default Photos;
